import { Component, Input } from '@angular/core';

@Component({
    selector: 'redispatch-labeled-textbox',
    templateUrl: './labeled-textbox.component.html',
    styleUrls: [
        './labeled-textbox.component.scss',
    ],
    standalone: false,
})
export class LabeledTextboxComponent {

    @Input()
    public label: string;

    @Input()
    public text: string | undefined;

    @Input()
    public required = false;

    constructor() {
    }

    public get addText(): string {
        if (this.text === '' || typeof this.text === undefined || this.text === null) {
            return ' - ';
        } else return this.text;
    }

}
